<template>
  <div class="card-modern">
    <div class="d-flex align-items-start justify-content-between mb-3 flex-wrap">
      <div>
        <h2 class="card-title-modern">
          Approval Evaluasi 
        </h2>
        <p class="card-desc-modern mb-0">
          Daftar evaluasi yang menunggu approval Anda.
        </p>
      </div>
      <!-- <button class="button-modern" :disabled="loading" @click="fetchList">
        <i class="bi bi-arrow-clockwise me-1"></i> Refresh
      </button> -->
    </div>
  
    <!-- Toolbar -->
    <div class="d-flex flex-wrap gap-2 align-items-center justify-content-end mb-3">
      <div class="flex-grow-1" style="min-width: 200px; max-width: 320px">
        <input v-model="search" type="text" class="form-control" placeholder="Cari nama perusahaan" />
      </div>
  
      <select v-model="statusFilter" class="form-select" style="width: auto; min-width: 160px" @change="onStatusChange">
        <option v-for="opt in statusOptions" :key="opt.value" :value="opt.value">
          {{ opt.label }}
        </option>
      </select>
    </div>
  
    <!-- Loading / Error -->
    <div v-if="loading" class="text-center py-5 text-muted">
      <div class="spinner-border spinner-border-sm me-2"></div>
      Memuat data...
    </div>
    <div v-else-if="loadError" class="alert alert-danger">
      Gagal memuat daftar evaluasi. Silakan coba lagi.
    </div>
  
    <!-- Table -->
    <div v-else class="modern-table-wrapper">
      <table class="table-modern">
        <thead>
          <tr>
            <th>Nama Perusahaan</th>
            <th>Penilai</th>
            <th class="text-center">Skor</th>
            <th>Tanggal Evaluasi</th>
            <th>Diajukan</th>
            <th class="text-center">Status</th>
            <th class="text-center">Aksi</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="pagedItems.length === 0">
            <td colspan="7" class="text-center text-muted py-4">
              Tidak ada data evaluasi
            </td>
          </tr>
          <tr v-for="item in pagedItems" :key="item.evaluation_id">
            <td>{{ item.nama_supplier || "-" }}</td>
            <td>{{ item.penilai_name || "-" }}</td>
            <td class="text-center">
              <span class="badge-modern" :class="scoreBadgeClass(item.total_score)">
                {{
                item.total_score != null
                ? Number(item.total_score).toFixed(2)
                : "-"
                }}
              </span>
            </td>
            <td>{{ formatDate(item.evaluation_date) }}</td>
            <td>{{ formatDate(item.submitted_on) }}</td>
            <td class="text-center">
              <span class="badge-modern" :class="statusBadgeClass(item.status_approval)">
                {{ item.status_label || item.status_approval || "-" }}
              </span>
            </td>
            <td class="text-center">
              <div class="d-inline-flex align-items-center">
                <!-- Detail: semua user -->
                <button type="button" class="btn-icon-hover icon-primary" title="Detail" @click="goToDetail(item)">
                  <i class="bi bi-eye"></i>
                </button>
  
                <!-- Buat Ulang: hanya pembuat + status REJECTED -->
                <button v-if="item.can_redo" type="button" class="btn-icon-hover icon-warning" title="Buat Ulang Evaluasi"
                  @click="goToRedo(item)">
                  <i class="bi bi-arrow-repeat"></i>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  
    <!-- Pagination -->
    <div v-if="!loading && total > 0" class="d-flex justify-content-between align-items-center mt-3 flex-wrap gap-2">
      <small class="text-muted">
        Menampilkan {{ (page - 1) * perPage + 1 }} –
        {{ Math.min(page * perPage, total) }} dari {{ total }} data
      </small>
      <div class="d-flex align-items-center gap-2">
        <select v-model.number="perPage" class="form-select" style="width: auto" @change="page = 1">
          <option v-for="n in perPageOptions" :key="n" :value="n">
            {{ n }} / halaman
          </option>
        </select>
        <nav>
          <ul class="pagination pagination-sm mb-0">
            <li class="page-item" :class="{ disabled: page <= 1 }">
              <a class="page-link" href="#" @click.prevent="changePage(page - 1)">&lsaquo;</a>
            </li>
            <li v-for="(p, idx) in visiblePages" :key="idx" class="page-item"
              :class="{ active: p === page, disabled: p === '...' }">
              <a class="page-link" href="#" @click.prevent="changePage(p)">{{
                p
                }}</a>
            </li>
            <li class="page-item" :class="{ disabled: page >= totalPages }">
              <a class="page-link" href="#" @click.prevent="changePage(page + 1)">&rsaquo;</a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
import EvaluationApprovalView from "./EvaluationApprovalView";
export default EvaluationApprovalView;
</script>